
let urls = {
    SiteUrl:"https://asooone.ir/",
    baseUrl:"https://asooone.ir/api/client/v1/",
    menuImages:"https://asooone.ir/upload/menuapp/",
    menuItemImages:"https://asooone.ir/upload/menuItem/",
    checkUpdate:"check_update",
    setCity:"set_city",
    getCities:"get_cities",
    login:"login",
    register:"modifiedRegister",
    verify:"verifyModified",
    checkClient:"check_client",
    getMainMenu:"get_admin_menu",
    getCatShop:"allcat",
    getShopList:"catshop_show",
    getAllCategoriesOfStore_V96:"getAllCategoriesOfStore_V96",
    getShop:"getshop",
    getProductsOfStore:"get_products_of_this_shop",
    addOrder:"add_order",
    getAddress:"get_android_user_address",
    addAddress:"add_address",
    getArea:"get_mahalat",
    updateOrder:"update_order_address",
    payment:"payment",
    getLastOrders:"get_last_order3",
    ShowOrder:"ShowOrder",
    history_wallet:"history_wallet",
    search:"searchModified",
    getCategoriesForSearch:"getCategoriesForSearch",
    getDivarList:"get_list_divar",
    new_products:"new_products",
    get_arzansara:"getListOfGroceryProducts",
    get_news:"get_news",
    getDelivery:"get_delivery_support",
    getServices:"get_catkh",
    getAmazing:"getListOfAmazingProducts",
    listkhadamati:"listkhadamati",
    serviceShow:"khadamati_show",
    favorites:"myfavpro",
    product_fav:"product_fav",
    getProduct:"product_show",
    payWallet:"user/wallet",
    checkGiftCard:"check_gift_card",
    getMessages:"get_last_message",
    getComments:"get_comments_of",
    deleteAddress:"del_address",
    getExtraProductsFromHomeItem:"getExtraProductsFromHomeItem",
    getExtraStoresFromHomeItem:"extraShopsFromHomeItems",
    getProductsById:"getProductsFromSlider",
    getStoresById:"catshop_show",

};

 export default urls;